(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["collection-navigation"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('distopion-collection-navigation')) {
    customElements.define('distopion-collection-navigation', class extends HTMLElement {
      constructor() {
        super();
        this.scheduleUpdate = () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => {
            this.frame = null;
            this.updateEdges();
          });
        };
      }

      connectedCallback() {
        this.list = null;
        this.addEventListener('scroll', this.scheduleUpdate, { passive: true });
        this.observer = new ResizeObserver(this.scheduleUpdate);
        this.observer.observe(this);
        this.scheduleUpdate();
      }

      disconnectedCallback() {
        this.removeEventListener('scroll', this.scheduleUpdate);
        this.observer?.disconnect();
        cancelAnimationFrame(this.frame);
        this.frame = null;
      }

      updateEdges() {
        if (!this.isConnected) return;
        if (!this.list) {
          this.list = this.querySelector('.distopion-collection-nav__list');
          if (!this.list) return;
          this.observer?.observe(this.list);
        }
        const viewport = this.getBoundingClientRect();
        const content = this.list.getBoundingClientRect();
        this.toggleAttribute('data-fade-left', content.left < viewport.left - 1);
        this.toggleAttribute('data-fade-right', content.right > viewport.right + 1);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pdp-review-summary"] && !Shopify.designMode) return;
  try {
    (() => {
    let sharedDialog;
    let loading;
    let ready = false;
    let opener;

    const showStatus = (dialog, failed) => {
      dialog.querySelector('.dp-review-modal__status').hidden = false;
      dialog.querySelector('[data-dp-review-loading]').hidden = failed;
      dialog.querySelector('[data-dp-review-error]').hidden = !failed;
      dialog.querySelector('[data-dp-review-retry]').hidden = !failed;
    };

    const loadStyles = async (base, key, signal) => {
      const response = await fetch(new URL('manifest.json', base), { signal });
      if (!response.ok) throw new Error('Review styles unavailable');
      const manifest = await response.json();
      const visited = new Set();
      const styles = new Set();
      const collect = (name) => {
        if (visited.has(name)) return;
        visited.add(name);
        const entry = manifest[name];
        if (!entry) return;
        (entry.css || []).forEach(file => styles.add(new URL(file, base).href));
        (entry.imports || []).forEach(collect);
      };
      collect(key);
      await Promise.all(Array.from(styles, href => {
        if (Array.from(document.styleSheets).some(sheet => sheet.href === href)) return;
        return new Promise((resolve, reject) => {
          const link = document.createElement('link');
          link.rel = 'stylesheet';
          link.href = href;
          const abort = () => { link.remove(); reject(new Error('Review styles timed out')); };
          signal.addEventListener('abort', abort, { once: true });
          link.onload = () => { signal.removeEventListener('abort', abort); resolve(); };
          link.onerror = () => {
            signal.removeEventListener('abort', abort);
            link.remove();
            reject(new Error('Review style failed'));
          };
          document.head.append(link);
        });
      }));
    };

    const load = (dialog) => {
      if (loading || ready) return;
      const content = dialog.querySelector('[data-dp-review-content]');
      showStatus(dialog, false);
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 15000);
      loading = (async () => {
        try {
          if (!content.childElementCount) {
            const url = new URL(content.dataset.src, location.origin);
            if (content.dataset.previewTheme) url.searchParams.set('preview_theme_id', content.dataset.previewTheme);
            const response = await fetch(url, { signal: controller.signal, credentials: 'same-origin' });
            if (!response.ok) throw new Error('Reviews unavailable');
            const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
            const main = doc.querySelector('#main');
            const data = main?.querySelector('.jdgm-all-reviews-widget-v2025-data-json');
            const widget = main?.querySelector('.jdgm-all-reviews-widget-v2025[data-entry-point]');
            if (!widget || !data || !window.jdgm?.CDN_BASE_URL) throw new Error('Reviews unavailable');
            window.jdgm.data ||= {};
            window.jdgm.data.allReviewsWidgetV2025 = JSON.parse(data.textContent);
            main.querySelectorAll('script, iframe, object, embed').forEach(node => node.remove());
            content.replaceChildren(...main.childNodes);
          }
          const widget = content.querySelector('.jdgm-all-reviews-widget-v2025');
          const base = window.jdgm.CDN_BASE_URL;
          const entry = new URL(widget.dataset.entryPoint, base);
          const mounted = new Promise((resolve, reject) => {
            if (widget.hasAttribute('data-v-app')) { resolve(); return; }
            const observer = new MutationObserver(() => {
              if (widget.hasAttribute('data-v-app')) { cleanup(); resolve(); }
            });
            const abort = () => { cleanup(); reject(new Error('Reviews timed out')); };
            const cleanup = () => { observer.disconnect(); controller.signal.removeEventListener('abort', abort); };
            observer.observe(widget, { attributes: true, attributeFilter: ['data-v-app'] });
            controller.signal.addEventListener('abort', abort, { once: true });
          });
          await Promise.all([
            loadStyles(base, widget.dataset.entryKey, controller.signal),
            import(entry.href),
            mounted
          ]);
          ready = true;
          dialog.querySelector('.dp-review-modal__status').hidden = true;
          content.hidden = false;
        } catch (error) {
          controller.abort();
          showStatus(dialog, true);
        } finally {
          clearTimeout(timeout);
          loading = null;
        }
      })();
    };

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-dp-review-modal-open]');
      if (trigger) {
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
        const dialog = sharedDialog || document.getElementById(trigger.dataset.dpReviewModalOpen);
        if (!dialog || typeof dialog.showModal !== 'function') return;
        event.preventDefault();
        if (!sharedDialog) {
          sharedDialog = dialog;
          document.body.append(dialog);
          dialog.addEventListener('close', () => opener?.focus({ preventScroll: true }));
        }
        opener = trigger;
        trigger.setAttribute('aria-controls', dialog.id);
        if (!dialog.open) dialog.showModal();
        load(dialog);
        return;
      }
      const dialog = event.target.closest('.dp-review-modal');
      if (!dialog) return;
      if (event.target.closest('[data-dp-review-retry]')) load(dialog);
      if (event.target.closest('[data-dp-review-modal-close]') || event.target === dialog) dialog.close();
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
